import EventBus from '/@/modules/core/app/helpers/EventBus';
import { unreadNotificationCount } from '@/modules/notification/store/notification.state';
import { NotificationBroadcast } from '@/modules/notification/models/NotificationBroadcast';

export function setUnreadNotificationCount(notificationCount: number): void {
  unreadNotificationCount.value = notificationCount;
}

export function unsetUnreadNotificationCount(): void {
  unreadNotificationCount.value = 0;
}

export function incrementNotificationCount(): void {
  unreadNotificationCount.value += 1;
}

export function decrementNotificationCount(): void {
  if (unreadNotificationCount.value) {
    unreadNotificationCount.value -= 1;
  }
}

export function removeFromNotificationCount(count: number): void {
  if (unreadNotificationCount.value) {
    unreadNotificationCount.value = unreadNotificationCount.value - count;
  }
}

export function actionOnNotification(broadcast: NotificationBroadcast): void {
  const { notification } = broadcast;
  EventBus.signal(notification?.type as string, notification, broadcast.isUndo);
}
